import React from 'react';
import BaseField, { BaseFieldProps } from '../BaseField/BaseField';
import FileUpload from './FileUpload';

const FileUploadField: React.FC<BaseFieldProps> = props => {
	return (
		<BaseField {...props}>
			<FileUpload />
		</BaseField>
	);
};

export default FileUploadField;
